<nz-steps [nzCurrent]="currentStep">
    <nz-step *ngFor="let step of steps" [nzTitle]="step.title"></nz-step>
</nz-steps>

<!-- Step Content Area (ng-template) -->
<div class="steps-content">
    <ng-template #stepContainer></ng-template>
</div>

<!-- Action Buttons -->
<div class="steps-action">
    <button nz-button nzType="default" (click)="prev()" *ngIf="currentStep > 0">
        Previous
    </button>
    <button nz-button nzType="primary" (click)="next()" *ngIf="currentStep < steps.length - 1">
        Next
    </button>
    <!-- <button nz-button nzType="primary" (click)="done()" *ngIf="currentStep === steps.length - 1">
        Done
    </button> -->
    <button nz-button nz-dropdown [nzDropdownMenu]="menu" *ngIf="currentStep === steps.length - 1">
  Publish/Done <nz-icon nzType="down"></nz-icon>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="done('published')">Publish</li>
    <li nz-menu-item (click)="done('draft')">Done</li>
    <li nz-menu-item (click)="done('draft')">Unpublish</li>
  </ul>
</nz-dropdown-menu>
</div>